import { Route, Routes } from "react-router-dom";
import styled from "styled-components";
import Footer from "./footer";
import Gallery from "./gallery";
import Header from "./header";
import MainPage from "./main";
import Nav from "./nav";
import AboutUs from "./about-us";

function Layout() {
  return (
    <>
      <Nav />

      <Routes>
        <Route
          path="/"
          element={
            <>
              <Header />
              <Content>
                <div style={{ maxWidth: "2500px" }}>
                  <MainPage />
                  <Footer />
                </div>
              </Content>
            </>
          }
        />

        <Route
          path="/gallery"
          element={
            <div style={{ maxWidth: "2500px" }}>
              <Gallery />
              <Footer />
            </div>
          }
        />

        <Route
          path="/about-us"
          element={
            <div style={{ maxWidth: "2500px" }}>
              <AboutUs />
              <Footer />
            </div>
          }
        />
      </Routes>

      <svg
        width="0"
        height="0"
        style={{ position: "absolute" }}
        aria-hidden="true"
      >
        <filter id="duoForest" colorInterpolationFilters="sRGB">
          <feColorMatrix
            type="matrix"
            values="0.2126 0.7152 0.0722 0 0
              0.2126 0.7152 0.0722 0 0
              0.2126 0.7152 0.0722 0 0
              0 0 0 1 0"
          />
          <feComponentTransfer>
            <feFuncR type="table" tableValues="0.098 0.926" />
            <feFuncG type="table" tableValues="0.204 0.945" />
            <feFuncB type="table" tableValues="0.086 0.906" />
          </feComponentTransfer>
        </filter>
      </svg>
    </>
  );
}
export default Layout;

const Content = styled.div`
  position: relative;
  top: 100vh;
  background: white;
`;
